import React from 'react';
import { withErrorBoundary } from '@bloomays-lib/common.monitoring/browser';
import { FallbackError } from './FallbackError';

const WithErrorBoundary = (WrappedComponent: () => React.ReactNode) => {
  return withErrorBoundary(WrappedComponent, {
    fallback: ({ error }: { error: unknown; componentStack: string; eventId: string; resetError: () => void }) =>
      React.createElement(FallbackError, { errorText: (error as Error)?.message }),
  });
};

export { WithErrorBoundary };
export default WithErrorBoundary;
